import { useQuery } from '@tanstack/react-query';
import { DictResponse } from '@spilca/order_ts/v1/order/enum_pb';
import { QUERY_KEYS } from '@monorepo/helpers';
import { translateNormalizedDictionary } from '@monorepo/dictionary';
import { REQUEST_TYPES, useGetRequest } from '@monorepo/requests';

const useGetQuantityTypes = (
  filter: object | undefined,
  active: string | null = null
) => {
  const getListOrderQuantityType = useGetRequest(
    REQUEST_TYPES.GET_ORDERS_QUANTITY_TYPES_REQUEST
  );
  return useQuery({
    queryKey: [QUERY_KEYS.LIST_ORDERS_QUANTITY_TYPES, filter],
    queryFn: (d): Promise<DictResponse.AsObject> =>
      getListOrderQuantityType({ ...d, active }),
    refetchOnWindowFocus: false,
    retry: false,
    staleTime: 10*60*1000,
    gcTime: 60*1000,
    placeholderData: (previousData) => previousData,
    select: translateNormalizedDictionary(
      null,
      null,
      'id',
      (item) => `listorderquantitytype-${item.id}-${item.name}`
    )
  });
};

export default useGetQuantityTypes;
